import { render, staticRenderFns } from "./card-switch.vue?vue&type=template&id=6fab28d2&"
import script from "./card-switch.vue?vue&type=script&lang=js&"
export * from "./card-switch.vue?vue&type=script&lang=js&"
import style0 from "./card-switch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports